export function toMobileImageUrl(url) {
  if (!url) return url;

  try {
    const u = new URL(url);

    const pathname = u.pathname;
    const lastSlash = pathname.lastIndexOf('/');
    const dir = pathname.substring(0, lastSlash + 1);
    const filename = pathname.substring(lastSlash + 1);

    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex === -1) return url; // no extension, bail

    const name = filename.substring(0, dotIndex);
    const ext = filename.substring(dotIndex); // includes dot

    const mobileFilename = `${name}_mobile${ext}`;

    u.pathname = dir + mobileFilename;

    return u.toString();
  } catch {
    // fallback for relative or malformed URLs
    return url.replace(/(\.[^.\/?#]+)(\?.*)?$/, '_mobile$1$2');
  }
}
